
export default class MonitoringKontingentDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.kontingentId = json.kontingentId
      this.verordnungId = json.verordnungId
      this.srNummer = json.srNummer
      this.art = json.art
      this.status = json.status
      this.periodeStart = json.periodeStart ? new Date(json.periodeStart) : null
      this.periodeEnde = json.periodeEnde ? new Date(json.periodeEnde) : null
      this.periodeId = json.periodeId
      this.versendetElektronischOn = json.versendetElektronischOn ? new Date(json.versendetElektronischOn) : null
      this.versendetPostalischOn = json.versendetPostalischOn ? new Date(json.versendetPostalischOn) : null
      this.gpDownloadOn = json.gpDownloadOn ? new Date(json.gpDownloadOn) : null
      this.gpDownloadBy = json.gpDownloadBy
      this.berechneterWert = json.berechneterWert
      this.angepassterWert = json.angepassterWert
      this.verbrauch = json.verbrauch
    } else {
      this.json = {}
    }
  }

  get versandart() {
    if (this.versendetPostalischOn) {
      return 'verfuegung.versandart.brief'
    }
    return this.versendetElektronischOn ? 'verfuegung.versandart.elektronisch' : ''
  }

  get kontingent() {
    return this.angepassterWert ?? this.berechneterWert
  }

  get anteil() {
    return Math.round(this.verbrauch / this.kontingent * 100)
  }
}
